function generateFilters(filter, filterMode) {
  let filterString = null;

  if (filterMode && filterMode == 'or') {
    filterString = 'filteror=';

    for (let i in filter) {
      let filterObject = filter[i];

      for (let j in filterObject) {
        let currentFilter = 1;

        filterString += `${j}:${filterObject[j]}`;

        if (currentFilter < (Object.keys(filterObject).length)) {
          filterString += ',';
        }

        currentFilter++;
      }

      if (i < (filter.length - 1)) {
        filterString += ',';
      }
    }
  }
  else {
    filterString = 'filter=';
    let currentFilter = 1;

    for (let i in filter) {
      if(filter[i].constructor === Array) {
        let filterArray = filter[i];

        filterString += `${i}:`;

        for(let j in filterArray) {
          filterString += `${filterArray[j]}`;

          if (j < (filterArray.length - 1)) {
            filterString += '|';
          }
        }
      }
      else {
        filterString += `${i}:${filter[i]}`;
      }

      if (currentFilter < (Object.keys(filter).length)) {
        filterString += ',';
      }

      currentFilter++;
    }
  }

  return filterString;
}

export default {
  generateQueryString(filters, filterMode, limit, sort) {
    let queryString = '';

    if (filters || limit || sort) {
      queryString += '?'

      if(filters) {
        queryString += generateFilters(filters, filterMode);
      }

      if(limit) {
        if(queryString.length > 1) {
          queryString += '&';
        }

        queryString += 'limit=' + limit;
      }

      if(sort) {
        if(queryString.length > 1) {
          queryString += '&';
        }

        queryString += 'sort=' + sort;
      }
    }

    return queryString;
  }
}



// WEBPACK FOOTER //
// ./src/services/_ServiceUtilities.js